import React, { Component, Fragment } from 'react';
import { GoogleMap, Marker, Polygon } from '@react-google-maps/api';
import FormattedAddress from 'components/FormattedAddress';
import { Alert } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';

class Map extends Component {
	constructor(props) {
		super(props);
		this.layers = [];
	}

	getTileUrl = (props, map) => ({ x, y }, zoom) => {
		const tileSizeInPoints = 256 / Math.pow(2, zoom);
		const sw = map.getProjection().fromPointToLatLng(new google.maps.Point(x * tileSizeInPoints, y * tileSizeInPoints + tileSizeInPoints));
		const ne = map.getProjection().fromPointToLatLng(new google.maps.Point(x * tileSizeInPoints + tileSizeInPoints, y * tileSizeInPoints));

		const bbox = `${sw.lat()},${sw.lng()},${ne.lat()},${ne.lng()}`;

		const url = `${props.baseUrl}version=1.3.0&request=GetMap&Layers=${
			props.layers
		}&CRS=EPSG:4326&BBOX=${bbox}&WIDTH=255&HEIGHT=255&FORMAT=image/png&TRANSPARENT=true`;
		return url;
	};

	render() {
		const polygons = this.props.responsibilityAreas ? this.props.responsibilityAreas.map(polygon => polygon.paths) : [];

		// Ganze Google Maps als Polygon markieren um dann die Polygone auszuschneiden
		const world = [
			[
				// Uhrzeigersinn
				// { lat: 90, lng: 0 },
				// { lat: 90, lng: 180 },
				// { lat: -90, lng: 180 },
				// { lat: -90, lng: 0 },
				// { lat: -90, lng: -180 },
				// { lat: 0, lng: -180 },
				// { lat: 90, lng: -180 },
				// { lat: 90, lng: 0 }

				// gegen Uhrzeigersinn
				{ lat: 90, lng: 0 },
				{ lat: 90, lng: -180 },
				{ lat: 0, lng: -180 },
				{ lat: -90, lng: -180 },
				{ lat: -90, lng: 0 },
				{ lat: -90, lng: 180 },
				{ lat: 90, lng: 180 },
				{ lat: 90, lng: 0 }
			]
		];
		// Einfügen der Polygone in die Welt als Loch (Uhrzeigersinn)
		for (var i = 0, len = polygons.length; i < len; i++) {
			for (var x = 0, len2 = polygons[i].length; x < len2; x++) {
				world.push(polygons[i][x]);
			}
		}

		return (
			<Fragment>
				{this.props.mapCenter.lat && this.props.mapCenter.lng && (
					<GoogleMap
						zoom={12}
						center={this.props.mapCenter}
						mapContainerStyle={{
							minHeight: 400,
							height: '100%',
							width: '100%'
						}}
						options={{
							fullscreenControl: false,
							mapTypeControl: true,
							panControlOptions: false,
							rotateControlOptions: false,
							zoomControl: false,
							streetViewControl: false
						}}
						onClick={({ latLng }) => this.props.onSelectLocation(latLng.lat(), latLng.lng())}
						onLoad={map => {
							if (this.props.layers) {
								this.props.layers.forEach((props, index) => {
									const layer = new window.google.maps.ImageMapType({
										getTileUrl: (tile, zoom) => this.getTileUrl(props, map)(tile, zoom),
										tileSize: new window.google.maps.Size(256, 256),
										minZoom: 14,
										maxZoom: 24,
										opacity: 0,
										isPng: true
									});

									this.layers[index] = layer;
									map.overlayMapTypes.setAt(index, layer);
								});

								const controlDiv = document.createElement('div');
								controlDiv.style.marginRight = '10px';
								// Create the control.

								const controlButton = document.createElement('div');

								// Set CSS for the control.
								controlButton.style.backgroundColor = '#fff';
								controlButton.style.border = '2px solid #fff';
								controlButton.style.borderRadius = '3px';
								controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
								controlButton.style.color = 'rgb(25,25,25)';
								controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
								controlButton.style.fontSize = '16px';
								controlButton.style.lineHeight = '38px';
								controlButton.style.margin = '8px 0 22px';
								controlButton.style.padding = '0 5px';
								controlButton.style.textAlign = 'left';

								const checkbox = document.createElement('input');
								checkbox.type = 'checkbox';
								checkbox.id = 'showLayerSelection';

								checkbox.addEventListener('change', ev => {
									const elements = document.getElementsByClassName('customControlCheckBox');
									for (var i = 0; i < elements.length; i++) {
										elements[i].style.display = ev.target.checked ? 'flex' : 'none';
									}
								});

								const label = document.createElement('label');
								label.htmlFor = 'showLayerSelection';
								label.style.paddingLeft = '5px';
								label.appendChild(document.createTextNode('Ebenenauswahl anzeigen'));
								const inputContainer = document.createElement('div');

								inputContainer.style.display = 'flex';

								inputContainer.appendChild(checkbox);
								inputContainer.appendChild(label);
								controlButton.appendChild(inputContainer);

								this.layers.forEach((l, i) => {
									const checkbox = document.createElement('input');
									checkbox.type = 'checkbox';
									checkbox.id = `layerCheck_${i}`;

									checkbox.addEventListener('change', ev => {
										l.setOpacity(ev.target.checked ? 1 : 0);
									});

									const label = document.createElement('label');
									label.htmlFor = `layerCheck_${i}`;
									label.style.paddingLeft = '5px';
									label.appendChild(document.createTextNode(this.props.layers[i].title));
									const inputContainer = document.createElement('div');

									inputContainer.style.display = 'none';
									inputContainer.className = 'customControlCheckBox';

									inputContainer.appendChild(checkbox);
									inputContainer.appendChild(label);
									controlButton.appendChild(inputContainer);
								});

								controlDiv.appendChild(controlButton);
								map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
							}
						}}
					>
						{this.props.responsibilityAreas.map((polygon, index) => (
							<Polygon
								key={index}
								options={{
									fillColor: this.props.mapsFillColor || '#000000',
									fillOpacity: '0.1',
									strokeColor: this.props.mapsStrokeColor || '#000000',
									strokeOpacit: '0.8',
									strokeWeight: 2
								}}
								paths={world}
								// onClick={({ latLng }) => this.props.onSelectLocation(latLng.lat(), latLng.lng())}
							/>
						))}
						{this.props.selectedLocation.lat && this.props.selectedLocation.lng && <Marker position={this.props.selectedLocation} />}
					</GoogleMap>
				)}
				{(this.props.address.zip || this.props.city || this.props.street || this.props.addressToLocationLoading) && (
					<Alert className="border bg-white mx-3 mb-3" color="default" style={{ position: 'absolute', bottom: 0 }}>
						{this.props.addressToLocationLoading ? (
							<div>
								<i className="zmdi zmdi-spinner zmdi-hc-spin mr-2" />
								<IntlMessages id="newReport.citizen.addressToLocationLoading" />
							</div>
						) : (
							<div>
								<FormattedAddress address={this.props.address} />
							</div>
						)}
					</Alert>
				)}
			</Fragment>
		);
	}
}

export default Map;



// WEBPACK FOOTER //
// ./containers/NewReport/Component/Map.js